export default "/_next/static/images/Baroque-766a79439efa72d956420119fb944b7f.png";